<template>
	<v-dialog v-model="visible_local" :max-width="maxWidth">
		<v-alert class="mb-0 rounded-b-0" type="error" v-if="error_msg.length !== 0">
			{{ error_msg }}
		</v-alert>
		<div class="share-dialog pa-4">
			<div class="share-title">Link</div>
			<v-textarea
				class="mx-2"
				id="copylink"
				:value="link_url"
				background-color="#FFFFFF"
				outlined
				dense
				hide-details
				readonly
				auto-grow
				rows="1"
			></v-textarea>
			<v-btn depressed :color="'#00AAFD'" class="px-2 white--text text-capitalize" @click="onCopyLink()">
				<Copy class="mr-2" width="18" height="18" color="#FFFFFF"/>
				<span class="share-btn-text">Copy</span>
			</v-btn>
		</div>
	</v-dialog>
</template>
<script>
import Copy from '@/components/icons/copy';

export default {
	name: 'TaskCalendarShareDialog',
	props: {
		visible: {
			type: Boolean,
			default: false
		},
		maxWidth: {
			type: Number,
			default: 500
		},
		taskId: {
			type: Number,
			default:0
		},
	},
	components: {
		Copy
	},
	data() {
		return {
			error_msg: '',
			visible_local: this.visible,
		}
	},
	beforeDestroy() {
		if(this.tid) {
			clearTimeout(this.tid);
		}
	},
	watch: {
		visible_local() {
			if (!this.visible_local) {
				this.$emit('close');
			}
		}
	},
	computed: {
		link_url() {
			return `${window.location.origin}/task/${this.taskId}`;
		}
	},
	methods: {
		onCopyLink() {
			navigator.clipboard.writeText(this.link_url).then(() => {
				/* clipboard successfully set */
				this.$emit('copy-link', true);
				
			}, () => {
				/* clipboard write failed */
				this.$emit('copy-link', false);
				
			});
		}
	}
}
</script>
<style lang="scss" scoped>
.share-dialog {
	display: flex;
	flex-flow: row nowrap;
	justify-content: flex-start;
  align-items: center;
	background: #FFFFFF;
}
.share-title {
	font-family: Roboto;
	font-style: normal;
	font-weight: 400;
	font-size: 16px;
	line-height: 24px;
	color: #000000;
}
.share-btn-text {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 44px;
  color: #FFFFFF;
}
				
</style>